import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IAQSensorFilterForm from './components/IAQSensorFilterForm';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import { reset } from 'redux-form';
import { allUserSensorSelector } from '../../core/selectors/sensor.selector';
import _ from 'lodash';
import { sensorTypeOptions } from '../../constants/option.constant';
import modelEnum from '../../constants/model.enum';
import { convertLocalToUTC } from '../../constants/common.constant';

const IAQSensorFilter = (props: any) => {

  const { sensor }: any = useSelector((state: IState) => { return state.sensor });
  const userType: any = useSelector((state: IState) => { return state.auth.userType });
  const allUsersData: any = useSelector(allUserSensorSelector);

  const dispatch = useDispatch();

  const initialFilter = {
    Building: "",
    Comments: "",
    CustomerId: "",
    Floor: "",
    ICCID: "",
    Location: "",
    Room: "",
    SendMail: false,
    User: "",
    UserId: -1,
    SensorType: 0,
  };

  useEffect(() => {
    if (userType === 'Administrator')
      dispatch(actions.getAllUser(1, 10000, true));
    else
      dispatch(actions.getAllUser(1, 10000, false));

    const value = JSON.parse(JSON.stringify(localStorage.getItem('IAQSensor.Filter')));

    if (value) {
      dispatch(actions.getIAQSensorFilter());
    }
  }, []);

  let val = {
    CurrentPage: 1,
    PageSize: 10,
    OrderBy: 'desc',
    SensorLocationParam: {
      ICCID: '',
      CustomerId: '',
      Building: '',
      Floor: '',
      Room: '',
      Location: '',
    }
  };

  const onSubmitForm = (values: any) => {
    let tempValues = { ...values };
    
    values.UserId = values.UserId !== undefined ? +values.UserId : values.UserId;
    
    tempValues.SensorType = modelEnum.IAQ.toLowerCase();
    tempValues.LatestPayloadStartDateTime = tempValues.LatestPayloadStartDateTime || null;
    tempValues.LatestPayloadEndDateTime = tempValues.LatestPayloadEndDateTime || null;
    
    val.CurrentPage = 1;
    val.PageSize = props.pager.pageLimit;
    val.SensorLocationParam = values;
    
    if (!(_.isEqual(tempValues, initialFilter))) {
      if (tempValues.SensorType === modelEnum.IAQ.toLowerCase()) {
        dispatch(
          actions.getFilterIAQSensorsService({
            ...val,
            SensorLocationParam: {
              ...tempValues,
              LatestPayloadStartDateTime: convertLocalToUTC(tempValues.LatestPayloadStartDateTime),
              LatestPayloadEndDateTime: convertLocalToUTC(tempValues.LatestPayloadEndDateTime)
            }
          })
        );
      } else {
        dispatch(actions.getAllSensor({ ...val, SensorLocationParam: { ...tempValues } }));
      }

      localStorage.setItem(
        'IAQSensor.Filter',
        JSON.stringify(val.SensorLocationParam)
      );

      props.setHasFilterFun(val.SensorLocationParam);
    }

    props.modalClosed();
  };

  const onModalClosed = () => {
    dispatch(actions.resetAddSensorState());
    dispatch(actions.resetIAQSensorFilterState());
    dispatch(reset('IAQSensorFilterForm'));
    props.modalClosed();
  };
  
  const onClearFilter = () => {
    val.CurrentPage = props.pageInfo.currentPage;
    val.PageSize = props.pager.pageLimit;

    localStorage.removeItem('IAQSensor.Filter');

    props.setHasFilterFun("");
    props.clearfilter()
    props.modalClosed();
    
  };

  return (
    <React.Fragment>
      <IAQSensorFilterForm
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        onClearFilter={onClearFilter}
        getSensorLoading={sensor.loading}
        userList={allUsersData}
        sensorTypeList={sensorTypeOptions}
      />
    </React.Fragment>
  );
};

export default IAQSensorFilter;